import { SettlementState } from '@treadinc/horizon-api-spec';
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useStores } from '~store';
import {
  getDefaultSettlementStates,
  SettlementSearchParamName,
  SettlementSearchParams,
  settlementStatesByFilter,
} from '~store/SettlementsStore';

import { deriveSettlementsFiltersParamsFromQueryString } from '../DriverPay/driverPayHelpers';
import { parseQueryStringParams } from '../DriverPay/driverPayHelpers';
import { QSParams } from '../DriverPay/QSParams';
import SettlementsDataGrid from '../DriverPay/Settlements/SettlementsDataGrid';
import {
  parseSettlementStatusFilters,
  SETTLEMENT_STATUS_PARAM,
} from './components/Filters/SettlementStatusFilters';

const DriverPaySettlements = () => {
  const [searchParams] = useSearchParams();
  const queryStringParams = parseQueryStringParams(searchParams);
  const { settlementsStore } = useStores();

  const selectedStatusFilters = useMemo(() => {
    return parseSettlementStatusFilters(searchParams.get(SETTLEMENT_STATUS_PARAM));
  }, [searchParams]);

  useEffect(() => {
    const hasCategory = Boolean(searchParams.get('category'));

    if (hasCategory) {
      const settlementSearchParams: SettlementSearchParams = {
        [SettlementSearchParamName.SETTLEMENT_CATEGORY]:
          queryStringParams.category ?? undefined,
      };

      // Derive settlement states from selected status filters
      if (selectedStatusFilters.length > 0) {
        const settlementStates: SettlementState[] = selectedStatusFilters.flatMap(
          (filter) => settlementStatesByFilter[filter],
        );
        settlementSearchParams[SettlementSearchParamName.SETTLEMENT_STATES] =
          settlementStates;
      } else {
        // When no filters selected, exclude voided settlements by default
        // Voided settlements should only be shown when explicitly selected via the Void filter
        settlementSearchParams[SettlementSearchParamName.SETTLEMENT_STATES] =
          getDefaultSettlementStates();
      }

      const params = deriveSettlementsFiltersParamsFromQueryString(
        queryStringParams as QSParams,
      );

      // Preserve existing store params that aren't being set from URL
      // This prevents clearing filters when only the search param changes
      settlementsStore.setSearchParams({
        ...settlementsStore.searchParams,
        ...settlementSearchParams,
        ...params,
      });
    }
  }, [queryStringParams, selectedStatusFilters]);

  return <SettlementsDataGrid />;
};

export default DriverPaySettlements;
